import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=44faafdc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=44faafdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44faafdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44faafdc')) {
      api.createRecord('44faafdc', component.options)
    } else {
      api.reload('44faafdc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=44faafdc&scoped=true&", function () {
      api.rerender('44faafdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27yABboA4emuJ/JS/comp/PopupBox.vue"
export default component.exports